import { useEffect } from 'react';
import { useAppDispatch } from 'modules';
import { setLanguage } from 'modules/status';
import i18n from 'i18n';

export type TLanguage = 'ko' | 'ja' | 'vi' | 'en' | 'es' | 'zh';
/** i18n 언어변경 커스텀훅
 * @param language 바꿀언어
 */
export const useChangeLanguage = (language: TLanguage) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (language !== window.navigator.language) {
      i18n.changeLanguage(language);
    }
    dispatch(setLanguage(language));
  }, [language, dispatch]);
};
